
<div class="participant-course-tags-container">
  @for (item of items; track item) {
    <span class="participant-course-tags" [style.background-color]="item.colorHex" >{{ getTagLabel(item.tagName) }}</span>
  }
</div>
